import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import ProfileHeader from './ProfileHeader';
import ProfilePackageInfo from './ProfilePackageInfo';
import ProfileLinks from './ProfileLinks';
import OperatorAvatar from '../OperatorAvatar';
import { editOperatorStart } from 'redux/operators/operators.actions';
import MobileVerificationModal from 'components/MobileVerificationModal';
import { setIsMobileValidated } from 'redux/app/app.actions';

const getLocale = ({ appData }) => appData.locale;
const getPackageTypes = ({ paymentsData }) => paymentsData.packageTypes;
const getToEditedOperator = ({ operatorsData }) =>
  operatorsData.toEditedOperator;
const getProfile = ({ userData }) => userData.profile;
const getIsMobileValidated = ({ appData }) => appData.isMobileValidated;
const getMobileNumber = ({ appData }) => appData.mobileNumber;

const ProfilePopover = ({ handlePopoverOpen }) => {
  const [showMobileVerifyModal, setShowMobileVerifyModal] = useState(false);

  const locale = useSelector(getLocale);
  const packageTypes = useSelector(getPackageTypes);
  const profile = useSelector(getProfile);
  const isMobileValidated = useSelector(getIsMobileValidated);
  const toEditedOperator = useSelector(getToEditedOperator);
  const mobileNumber = useSelector(getMobileNumber);

  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    dispatch(editOperatorStart({ ...values, ...toEditedOperator }));
  };

  const handleCloseMobileVerificationModal = () => {
    setShowMobileVerifyModal(false);
    dispatch(setIsMobileValidated(true));
  };

  const {
    userId,
    fullName,
    email,
    accountType,
    remainingConversations,
    remainingDays,
    image,
  } = profile;

  useEffect(() => {
    if (!isMobileValidated) {
      setShowMobileVerifyModal(true);
    }
  }, [isMobileValidated]);

  return (
    <>
      {showMobileVerifyModal && (
        <MobileVerificationModal
          show={showMobileVerifyModal}
          onValidate={handleSubmit}
          onClose={handleCloseMobileVerificationModal}
          mobile={mobileNumber}
        />
      )}
      <a
        href='#/'
        onClick={(event) => event.preventDefault()}
        className='primary__menu__bottom__profile__avatar'
        rel='noreferrer noopener'
      >
        <OperatorAvatar
          avatarId={userId}
          imageUrl={image}
          fullName={fullName}
          wrapperClass='fallbackWrapper image'
        />
      </a>
      <div
        onClick={(e) => e.stopPropagation()}
        className='primary__menu__bottom__profile__menu'
      >
        <div className='primary__menu__bottom__profile__menu__inner'>
          <ProfileHeader fullName={fullName} email={email} />
          <ProfilePackageInfo
            packageType={packageTypes[accountType]?.[locale]}
            remainingConversations={remainingConversations}
            remainingDays={remainingDays}
          />
          <ProfileLinks {...{ handlePopoverOpen }} />
        </div>
      </div>
    </>
  );
};

export default ProfilePopover;
